import type { ReactNode } from 'react';
import { useAuth } from '@/auth/AuthProvider';
import { roleHasPermission, type Permission } from '@/auth/permissions';
import { ForbiddenPage } from '@/pages/StatusPages';

/** حارس الشاشة: لا صلاحية → شاشة «ممنوع» بذكر الصلاحية، لا شاشةٌ فارغة */
export function Guard({ permission, anyOf, children }: { permission: Permission; anyOf?: Permission[]; children: ReactNode }) {
  const { roles } = useAuth();
  // `anyOf`: بابٌ واحدٌ يدخله أكثرُ من صلاحية (سجلُّ الإدارة كاملاً، أو سجلُّ أفعال القسم وحده)
  if (![permission, ...(anyOf ?? [])].some((p) => roleHasPermission(roles, p))) return <ForbiddenPage permission={permission} />;
  return <>{children}</>;
}
